import { createContext } from 'react'
import RoutesState from '../types/routes_state'

const RoutesContext = createContext<RoutesState>({
    routes: []
})

export default RoutesContext
